var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"page-container"},[_vm._v("功能正在努力开发中"),_c('br'),_vm._v("等一段时间再来访问吧?\n\n\n        "),_c('router-link',{attrs:{"to":"/User/Users"}},[_vm._v("点击返回首页 ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }